import { stringToNumber } from './stringToNumber'

const MAX_DECIMAL_PLACES = 2

const formatNumberToQuantityString = (num: number): string => {
  const rounded = Math.round(num * 100) / 100
  let str = rounded.toFixed(MAX_DECIMAL_PLACES)
  str = str.replace(/\.?0+$/, '')
  return str.replace('.', ',')
}

const limitDecimalInput = (value: string): string => {
  const commaIndex = value.indexOf(',')
  if (commaIndex === -1) return value

  const intPart = value.slice(0, commaIndex)
  const decPart = value
    .slice(commaIndex + 1)
    .replace(/,/g, '')
    .slice(0, MAX_DECIMAL_PLACES)

  return `${intPart},${decPart}`
}

/** Interpreta allowDecimalQuantity retornado pela API (boolean, 0/1, string). */
export const getAllowDecimalQuantity = (
  source?: {
    allowDecimalQuantity?: unknown
    product?: { allowDecimalQuantity?: unknown }
  } | null
): boolean => {
  const value =
    source?.allowDecimalQuantity ?? source?.product?.allowDecimalQuantity

  if (value === true || value === 1) return true
  if (value === false || value === 0 || value == null) return false

  return false
}

/** Normaliza digitação de quantidade no formulário (vírgula como decimal). */
export const normalizeQuantityInput = (
  value: string,
  allowDecimal: boolean
): string => {
  if (!allowDecimal) return value.replace(/\D/g, '')

  const cleaned = value.replace(/\./g, ',').replace(/[^\d,]/g, '')
  const commaIndex = cleaned.indexOf(',')
  if (commaIndex === -1) return cleaned

  const intPart = cleaned.slice(0, commaIndex)
  const decPart = cleaned
    .slice(commaIndex + 1)
    .replace(/,/g, '')
    .slice(0, MAX_DECIMAL_PLACES)

  return `${intPart},${decPart}`
}

/** Converte quantidade numérica (API) para string com vírgula (formulário, máx. 2 decimais). */
export const numberToQuantityString = (
  value?: number | string | null
): string => {
  if (value == null || value === '') return ''

  if (typeof value === 'string') {
    const trimmed = value.trim()
    if (!trimmed) return ''

    if (trimmed.includes(',')) {
      const commaIndex = trimmed.indexOf(',')
      const decPart = trimmed.slice(commaIndex + 1)
      if (decPart === '') return limitDecimalInput(trimmed)

      const parsed = Number(stringToNumber(trimmed))
      if (!Number.isNaN(parsed)) {
        return formatNumberToQuantityString(parsed)
      }
      return limitDecimalInput(trimmed)
    }

    const parsed = Number(stringToNumber(trimmed))
    if (Number.isNaN(parsed)) return trimmed
    return formatNumberToQuantityString(parsed)
  }

  if (Number.isNaN(value)) return ''

  return formatNumberToQuantityString(value)
}
